<template>
  <el-dialog
    id="SowModal"
    title="Coaching Engagement Confirmation"
    :visible.sync="showLocal"
    :width="dialogWidth"
    :close-on-click-modal="false"
  >
    <div style="margin-bottom: 18px;">
      {{ $t('coach.leader.sow.congrats') }}:
    </div>

    <div class="field">
      <span class="boldLabel">
        {{ $t('coach.leader.sow.leaderName') }}:
      </span>
      {{ leader.first_name }} {{ leader.last_name }}
    </div>
    <div class="field">
      <span class="boldLabel">
        {{ $t('coach.leader.sow.coachingCategory') }}:
      </span>
      <template v-if="formattedCategory">
        {{ formattedCategory }}
      </template>
      <template v-else>
        {{ $t(`coachingTier.tier_${leader.tier}`) }}
        {{ $t(`coachingTier.tier_${leader.tier}_caption`) }}
      </template>
    </div>
    <div class="field">
      <span class="boldLabel">
        {{ $t('coach.leader.sow.durationOfEngagement') }}:
      </span>
      {{ leader.duration }} {{ $t('coach.leader.sow.durationSessions') }}
    </div>
    <div class="field">
      <span class="boldLabel">
        {{ $t('common.totalFeePayout') }}:
      </span>
      {{ formattedCategoryFee }}
    </div>
    <div class="field">
      {{ $t('coach.leader.sow.termDesc') }}:
      <a
        href="https://info.gcgroup.io/platform/payouts/"
        target="_blank"
      >
        https://info.gcgroup.io/platform/payouts/
      </a>
    </div>

    <div style="padding-top: 18px;">
      <el-checkbox
        v-model="checkAgreement"
        style="
        display: flex;
        word-break: break-word;
        white-space: normal;
        align-items: center;
        margin-bottom: 10px;
      "
      >
        <div style="padding-bottom: 2px;">
          <i18n path="coach.leader.sow.termAgreement">
            <template #sowFull>
              <el-button
                type="text"
                style="margin-left: 0; padding: 0;"
                @click.stop="openLink"
              >
                {{ $t('coach.leader.sow.sowFull') }}
              </el-button>
            </template>
          </i18n>
        </div>
      </el-checkbox>
    </div>

    <div style="text-align: center;">
      <el-button
        type="primary"
        round
        :disabled="!checkAgreement"
        @click="confirm"
      >
        {{ $t('common.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api';
import dialog from '@/mixins/dialog';

export default {
  name: 'SowModal',

  mixins: [dialog],

  props: {
    leader: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    checkAgreement: false,
  }),

  computed: {
    formattedCategory() {
      let defaultCategory = null;

      if (process.env.VUE_APP_SERVICE === 'ing_gcg_platform') {
        defaultCategory = this.$t('coachingTier.ingLeaders');
      }

      return defaultCategory;
    },

    formattedCategoryFee() {
      let charge = this.$t('common.na');
      if (!this.leader.is_invited && this.leader.total_payment_fee) {
        charge = `$ ${this.leader.total_payment_fee}`;
      }
      return charge;
    },
  },

  methods: {
    openLink() {
      let url = 'https://app.box.com/s/e51ru0deh27r4xiixnyy96dwxqi3h94h';
      if (process.env.VUE_APP_SERVICE === 'ing_gcg_platform') {
        url = 'https://app.box.com/s/02fk8ictjr4k7wsm4w9cy4mhahx7wmj9';
      }
      window.open(url, '_blank');
    },

    async confirm() {
      if (this.checkAgreement) {
        try {
          const sendData = { is_sow_confirmed: true };
          await api.saveCoachTask(this.leader.uuid, sendData);
          this.$emit('update:leader.is_sow_confirmed', true);
          this.showLocal = false;
        } catch (err) {
          console.log(err);
          this.$message.error(err.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #SowModal {
    div {
      word-break: break-word;
    }
    .field {
      margin-bottom: 10px;
      .boldLabel {
        font-weight: bold;
      }
    }
  }
</style>
